<template lang="pug">
  div
    v-card.team-selector
      v-card-title.pb-0 Teams
      v-list
        v-list-item-group(v-model="teamIdModel" color="white" mandatory)
          v-list-item(v-for="team in teams" :key="team.id")
            v-list-item-content
              .body-2.font-weight-bold {{team.team_name}}
              .body-2 {{team.division_name}}
      v-card-text(v-if="teams.length == 0").mt-0
        p You have no teams assigned for the selected season.
</template>

<script>
import { mapGetters } from "vuex"

export default({
  computed: {
    ...mapGetters(['teams']),
    teamIdModel: {
      get() {
        return this.teams.findIndex(team => team.id == this.$store.state.main.teamId)
      },
      set(value) {
        if(value || value == 0) {
          this.$store.dispatch('selectTeam', this.teams[value].id)
        }
      }
    }
  }
})
</script>

<style lang="stylus">
.team-selector
  .v-list-item--active
    background-color: #2E7D32;
  .v-list-item
    color: white;
    font-size: 1.2em;
</style>